/* Native details and Shopify dialogs remain usable without these enhancements. */
if (!customElements.get('nph-navigation')) {
  customElements.define('nph-navigation', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = {signal:this.controller.signal};
      const items = [...this.querySelectorAll('details.nph31-nav-item')];
      this.close = (except=null) => items.forEach(item => { if (item !== except) item.open = false; });
      items.forEach(item => item.addEventListener('toggle', () => {
        if (item.open) this.close(item);
        item.querySelector('summary')?.setAttribute('aria-expanded', String(item.open));
      }, options));
      document.addEventListener('pointerdown', event => { if (!this.contains(event.target)) this.close(); }, options);
      document.addEventListener('focusin', event => { if (!this.contains(event.target)) this.close(); }, options);
      this.addEventListener('keydown', event => {
        if (event.key === 'Escape') {
          const open = items.find(item => item.open);
          if (open) { event.preventDefault();this.close();open.querySelector('summary')?.focus(); }
        }
        const item=event.target.closest('details.nph31-nav-item');
        if (event.key === 'ArrowDown' && event.target === item?.querySelector('summary')) {
          event.preventDefault();this.close(item);item.open=true;item.querySelector('.nph31-mega a')?.focus();
        }
      }, options);
      window.addEventListener('resize', () => { if (window.innerWidth < 1000) this.close(); }, options);
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}
if (!customElements.get('nph-search-hints')) {
  customElements.define('nph-search-hints', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();this.controller=new AbortController();
      const input=this.closest('header-search')?.querySelector('input[name="q"]');
      if (!input) return;
      const update=()=>{this.hidden=Boolean(input.value.trim());};
      input.addEventListener('input',update,{signal:this.controller.signal});
      update();
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}
